/*
 * @Description: Flutter 菲律宾外场
 * @Author: gaolei
 * @Date: 2024-09-18
 * @LastEditTime: 2024-09-23 10:40:57
 * @LastEditors: gaolei
 */

import { useAuthStore } from '@/stores/login'
// import { updateUserInfo } from '@/utils/userInfo'
import 'vant/lib/index.css'
// import dsBridge from 'dsbridge'
import { loading } from '@/utils/loading'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import CryptoJS from 'crypto-js'
import router from '@/router'
import { useUsersStore } from '@/stores/users'

// 判断是否是Native App内嵌沙滩说
export const isSandsTalkPhOutfieldApp = window.navigator.userAgent.indexOf('PhOutfield') > -1

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const invokeMethod = async (params: string): Promise<any> => {
  try {
    // console.log('invokeMethod called with name:', params);
    if (window.flutter_inappwebview) {
      // console.log('window.flutter_inappwebview is available');
      if (typeof window.flutter_inappwebview.callHandler === 'function') {
        // console.log('window.flutter_inappwebview.callHandler is a function');
        return await window.flutter_inappwebview.callHandler(params)
      } else {
        await sleep(200)
        return window.flutter_inappwebview.callHandler(params)
      }
    } else {
      // console.error('window.flutter_inappwebview is not available');
      setTimeout(() => {
        window.location.replace(location.href)
      }, 200)
      return ''
    }
  } catch (error) {
    // console.error('Error in invokeMethod:', error);
    sandsTalkShowToastNative(error + '')
    return ''
  }
}

// 获取签名
function getSign(params: any, secret: any, timestamp: any) {
  const paramsJson = params ? JSON.stringify(params, Object.keys(params).sort()) : 'N_V'
  const stringToSign = `${paramsJson}\n${timestamp}\n${secret}`

  // 将 stringToSign 直接作为 HMAC 密钥使用，确保与 Java 逻辑一致
  const hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, CryptoJS.enc.Utf8.parse(stringToSign))
  const signData = hmac.finalize(CryptoJS.lib.WordArray.create([]))

  // 返回 Base64 编码的签名
  return CryptoJS.enc.Base64.stringify(signData)
}

// 获取沙滩说token
export const sandsTalkPhOutfieldLogin = async () => {
  loading.show()
  try {
    // 调用原生方法获取用户信息
    const res = await invokeMethod('SandsTalkUserInfoChannel')

    // 将返回的 JSON 字符串解析为对象，并添加错误处理
    let getUserInfor = JSON.parse(res) || {}

    let appId = ''
    let signSecret = ''
    let language = ''
    let identifierType = ''

    // 准备请求参数
    const timestamp = Date.now()
    // 印尼外场
    appId = 'ph_outfield_app' // 由沙滩说提供
    signSecret = '6hZYMBfeISlxrhXVk'
    identifierType = 'empNo'
    language = getUserInfor.lang === 'zh' ? 'zh-cn' : getUserInfor.lang === 'en' ? 'en-us' : 'en-us'
    localStorage.setItem('lang', language)
    // 存储原生给的用户信息数据到 localStorage
    localStorage.setItem('SandsTalkUserInfo', JSON.stringify(getUserInfor))

    const noce = uuidv4()

    const params = {
      appId,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.psCode || getUserInfor.empNo || '',
      noce,
      timestamp
    }

    // 生成签名
    const sign = getSign(params, signSecret, timestamp)

    // 构造最终的请求数据
    const finalRequestData = {
      appId,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.empNo || '',
      noce,
      sign,
      timestamp
    }

    // 发送请求
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL}/sands-user/api/v1/auth/authorization-token`,
        JSON.stringify(finalRequestData),
        {
          headers: {
            'Content-Type': 'application/json',
            'accept-language': language || 'en-us'
          }
        }
      )

      if (data.code === 1) {
        loading.hide()
        const authStore = useAuthStore()
        authStore.setAccessToken(data.data.access_token)
        localStorage.setItem('sandsTalkToken', data.data.access_token)
        localStorage.setItem('sandsTalkTenantId', data.data.tenantId || '1000')
        const usersStore = useUsersStore()
        const { setCollegeId } = usersStore
        setCollegeId(data.data.collegeId)
        // 更新本地缓存中的 users 数据
        // const users = JSON.parse(localStorage.getItem('users') || '{}')
        // users.collegeId = data.data.collegeId
        // localStorage.setItem('users', JSON.stringify(users))
        router.replace('/')
        return true
      } else {
        const authStore = useAuthStore()
        authStore.setAccessToken('')
        localStorage.removeItem('sandsTalkToken')
        loading.hide()
        sandsTalkShowToastNative(data.msg)
        sandsTalkNativeCloseWebview()
        return false
      }
    } catch (error) {
      const authStore = useAuthStore()
      authStore.setAccessToken('')
      localStorage.removeItem('sandsTalkToken')
      loading.hide()
      sandsTalkNativeCloseWebview()
      sandsTalkShowToastNative(error + '')
      return false
    }
  } catch (error) {
    const authStore = useAuthStore()
    authStore.setAccessToken('')
    localStorage.removeItem('sandsTalkToken')
    loading.hide()
    sandsTalkNativeCloseWebview()
    console.error('获取Token失败:', error)
    return false
  }
}

// 外场关闭webview
export const sandsTalkNativeCloseWebview = async () => {
  window.flutter_inappwebview.callHandler('FinishPageChannel')
}

export const sandsTalkShowToastNative = (msg: string) => {
  window.flutter_inappwebview.callHandler('ShowToastChannel', msg)
}

// 沙滩说下载H5链接  (文件下载)
export const sandsTalkNativeDownloadH5Url = (url: string, name: string) => {
  window.flutter_inappwebview.callHandler('OpenFileChannel', { url, name })
}

// 沙滩说设置标题
export const sandsTalkPhSetTitle = (str: string) => {
  window.flutter_inappwebview.callHandler('PageTitleChannel', str)
}

// 菲律宾 跳转外部链接
export const sandsTalkPhOpenUrl = (str: string) => {
  window.flutter_inappwebview.callHandler('goToNativeLoadUrl', str)
}

// 视频全屏
export const phSetHoriVerti = (isFull: boolean) => {
  window.flutter_inappwebview.callHandler('phSetHoriVerti', isFull)
}


